const { defineMessages } = require('react-intl');
const formCopy = defineMessages({
    login: {
        heading: {
            defaultMessage: 'Seller Account Login',
            id: 'login.heading',
        },
        inputLabelText1: {
            defaultMessage: 'Email',
            id: 'login.email',
        },
        inputLabelText2: {
            defaultMessage: 'Password',
            id: 'login.password',
        },
        resetPasswordLink: {
            defaultMessage: 'Forgot your password?',
            id: 'login.forgot_password',
        },
        subtitle: {
            defaultMessage: '',
            id: 'login.no_subtitle',
        },
    },
    message: {
        emailNotFoundseller: {
            defaultMessage:
                'Your email address was not found for this vertical. Please contact dealersupport@1stdibs.com if you believe this is an error.',
            id: 'login.message.email_not_found_seller',
        },
        invalidEmail: {
            defaultMessage: 'Please enter a valid email address.',
            id: 'login.message.invalid_email',
        },
        invalidVertical: {
            defaultMessage: 'Please enter an account type - eg. "furniture" or "jewelry".',
            id: 'login.message.invalid_vertical',
        },
        loginError: {
            defaultMessage: 'Your login credentials were incorrect, please try again.',
            id: 'login.message.login_error',
        },
        logoutSuccess: {
            defaultMessage: 'You have been successfully logged out.',
            id: 'login.message.logout_success',
        },
        pwResetSuccess: {
            defaultMessage: 'Your password has been successfully reset.',
            id: 'login.message.pw_reset_success',
        },
        resetExpired: {
            defaultMessage:
                'This link is no longer valid. Please use the most recent reset password link you have received within 24 hours.',
            id: 'login.message.reset_expired',
        },
        resetIdentityError: {
            defaultMessage:
                'There was an error communicating with this service, please contact support.',
            id: 'login.message.reset_identity_error',
        },
    },
    resetConfirmation: {
        confirmedNote: {
            defaultMessage:
                "Please check your inbox for an email from us. You'll need to follow the instructions in the email in order to continue.",
            id: 'login.reset_confirmation_copy',
        },
        confirmTip: {
            defaultMessage:
                "Allow 10 minutes for the email to arrive. If you still don't see it, check your spam folder. Double check that you’ve entered the correct email address which can be found in the account set up email you received.",
            id: 'login.reset_confirmation_tip',
        },
        confirmTipHeading: {
            defaultMessage: "Didn't get an email?",
            id: 'login.reset_confirmation_tip_heading',
        },
        heading: {
            defaultMessage: 'Check Your Email',
            id: 'login.reset_confirmation_heading',
        },
        subtitle: {
            defaultMessage: 'Step 2 of 3',
            id: 'login.reset_confirmation_subtitle',
        },
    },
    resetPassword: {
        heading: {
            defaultMessage: 'Create New Password',
            id: 'login.reset_password_heading',
        },
        inputLabelText1: {
            defaultMessage: 'New Password',
            id: 'login.reset_password_password',
        },
        inputLabelText2: {
            defaultMessage: 'Re-enter New Password',
            id: 'login.reset_password_password_confirmation',
        },
        subtitle: {
            defaultMessage: 'Step 3 of 3',
            id: 'login.reset_password_subtitle',
        },
    },
    resetPasswordEmail: {
        heading: {
            defaultMessage: 'Create New Password',
            id: 'login.reset_email_heading',
        },
        inputLabelText1: {
            defaultMessage: '1stdibs Account Email',
            id: 'login.reset_email_email',
        },
        subtitle: {
            defaultMessage: 'Step 1 of 3',
            id: 'login.reset_email_subtitle',
        },
        tooltip: {
            defaultMessage:
                "If this is your first time logging in and you're unsure of your selling category, you can find this information in your registration email.",
            id: 'login.reset_email_tooltip',
        },
    },
    validations: {
        matching: {
            defaultMessage: 'The password does not match. Please edit and try submitting again.',
            id: 'login.reset_password_match_error',
        },
        noError: {
            defaultMessage: '',
            id: 'login.no_error',
        },
        required: {
            defaultMessage: 'This field is required',
            id: 'login.field_required',
        },
        strength: {
            defaultMessage:
                'Passwords must be at least 8 characters long and contain at least one capital letter and one number',
            id: 'login.reset_password_strength_error',
        },
        validEmail: {
            defaultMessage: 'Please enter a valid email address.',
            id: 'login.invalid_email',
        },
    },
});

export default formCopy;
